import Button, { ButtonSizeType, ButtonStyleType } from './button';

export type { ButtonStyleType, ButtonSizeType };

export default Button;
